import { gql } from "@apollo/client";

/**
 * Subscription for real-time sentry session status (player view).
 * Replaces polling in ExtensionStreamDeckPanel and ModeratorStreamDeckPanel.
 */
export const ACTIVE_SENTRY_SESSION_SUBSCRIPTION = gql`
    subscription ActiveSentrySessionSubscription {
        activeSentrySessionCheckin {
            sessionId
            hasActiveSession
            checkedIn
        }
    }
`;

/**
 * Subscription for real-time spoils session status.
 * Replaces polling in ExtensionStreamDeckPanel and ModeratorStreamDeckPanel.
 */
export const ACTIVE_SPOILS_SESSION_SUBSCRIPTION = gql`
    subscription ActiveSpoilsSessionSubscription {
        activeSpoilsSessionStatus {
            sessionId
            hasActiveSession
            hasRedeemed
        }
    }
`;

/**
 * Subscription for real-time drink session status.
 * Replaces polling in ExtensionStreamDeckPanel and ModeratorStreamDeckPanel.
 */
export const ACTIVE_DRINK_SESSION_SUBSCRIPTION = gql`
    subscription ActiveDrinkSessionSubscription {
        activeDrinkSessionStatus {
            sessionId
            hasActiveSession
            hasRedeemed
        }
    }
`;

/**
 * Subscription for real-time clan spoils session status.
 * Replaces polling in ExtensionStreamDeckPanel and ModeratorStreamDeckPanel.
 */
export const ACTIVE_CLAN_SPOILS_SESSION_SUBSCRIPTION = gql`
    subscription ActiveClanSpoilsSessionSubscription($clanTag: String) {
        activeClanSpoilsSessionStatus(clanTag: $clanTag) {
            sessionId
            hasActiveSession
            hasRedeemed
        }
    }
`;

/**
 * Subscription for real-time checkin session status.
 * Replaces polling in ExtensionStreamDeckPanel and ModeratorStreamDeckPanel.
 */
export const ACTIVE_CHECKIN_SESSION_SUBSCRIPTION = gql`
    subscription ActiveCheckinSessionSubscription {
        activeCheckinSessionStatus {
            sessionId
            hasActiveSession
            checkedIn
        }
    }
`;

/**
 * Subscription for real-time raid session status.
 * Replaces polling in ExtensionStreamDeckPanel and ModeratorStreamDeckPanel.
 */
export const ACTIVE_RAID_SESSION_SUBSCRIPTION = gql`
    subscription ActiveRaidSessionSubscription {
        activeRaidSessionStatus {
            sessionId
            hasActiveSession
            checkedIn
        }
    }
`;

/**
 * Subscription for real-time hype train loot session status.
 * Replaces polling in ExtensionStreamDeckPanel and ModeratorStreamDeckPanel.
 */
export const ACTIVE_HYPE_TRAIN_LOOT_SESSION_SUBSCRIPTION = gql`
    subscription ActiveHypeTrainLootSessionSubscription {
        activeHypeTrainLootSessionStatus {
            sessionId
            hasActiveSession
            redeemed
        }
    }
`;

/**
 * Subscription for real-time wheel of hamingja redemption session status.
 * Replaces polling in ExtensionStreamDeckPanel and ModeratorStreamDeckPanel.
 */
export const ACTIVE_WHEEL_OF_HAMINGJA_REDEMPTION_SESSION_SUBSCRIPTION = gql`
    subscription ActiveWheelOfHamingjaRedemptionSessionSubscription {
        activeWheelOfHamingjaRedemptionSessionStatus {
            sessionId
            hasActiveSession
            hasAvailableTokens
        }
    }
`;

/**
 * Subscription for real-time wheel of hamingja session status.
 * Replaces polling in ExtensionStreamDeckPanel and ModeratorStreamDeckPanel.
 */
export const ACTIVE_WHEEL_OF_HAMINGJA_SESSION_SUBSCRIPTION = gql`
    subscription ActiveWheelOfHamingjaSessionSubscription {
        activeWheelOfHamingjaSessionQueryStatus {
            sessionId
            hasActiveSession
            claimed
        }
    }
`;
